import React from "react";
import "./Footer.css";

const Footer = () => {
	return (
		<div className="text-center footer">
			<p>© 2024&nbsp;<a href="https://www.instagram.com/federico.galeasso/" target="_blank">Federico Galeasso</a>. All rights reserved.</p>
		</div>
	);
};

export default Footer;
